import { Component, OnInit, Output } from '@angular/core';
import { UserProfile } from 'src/app/models/userProfile';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { User } from 'src/app/models/user';
import { UserRestriction } from 'src/app/models/UserRestriction';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';


@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  user: UserProfile;
  loggendInUser: User;
  experiencedMode;
  modelQuality = 0;
  ab = true;
  userRestriction: UserRestriction = new UserRestriction();
  response: any;
  buttonClicked = true;
  userProfileImageURL: string = 'assets/img/userDefault.png';
  isShowNotificationSuccess: boolean;
  showSuccessMessage: string;
  //https://upload.wikimedia.org/wikipedia/commons/d/db/Ernst_Werner_von_Siemens.jpg
  
  themeType:string;
  
  constructor(private userhttpService: UserService) { }

  ngOnInit() {
    // Getting the userInfo
    if (sessionStorage.getItem("userinfo")) {
      this.loggendInUser = JSON.parse(sessionStorage.getItem("userinfo"));
    }
    this.themeType = this.loggendInUser.userSettings.userThemeType===0?'dark':'light';
    this.fetchUserProfileImage(this.userhttpService.loggendInUser.userEmailId);
    this.userRestriction = this.loggendInUser.userSettings.userRestriction ? this.loggendInUser.userSettings.userRestriction : this.userRestriction;
    this.user = this.userhttpService.loggendInUser.userSettings;
    this.experiencedMode = this.loggendInUser.userSettings.userProfileType ? 'On' : 'Off';
    this.user.name = this.loggendInUser.userEmailId;
  }

  changeUserMode(experiencedMode) {
    this.buttonClicked = false;
    setTimeout(() => {
      if (experiencedMode === 'On') {
        this.experiencedMode = 'Off';
        this.loggendInUser.userSettings.userProfileType = 0;
      }
      else {
        this.experiencedMode = 'On';
        this.loggendInUser.userSettings.userProfileType = 1;
      }
    
    });
  }

  /**
   * On changing the checkbox values.
   */
  changeCheckBoxValue(obj, param) {
    this.buttonClicked = false;
    this.ab = false;
    // if (!sessionStorage.getItem("checked") || sessionStorage.getItem("checked") !== "1") {
    //   //data = !data;
    //   obj[param] = !obj[param];
    //   sessionStorage.setItem("checked", "1");
    // } else sessionStorage.setItem("checked", "0");
    setTimeout(() => {
      obj[param] = !obj[param];
    });
  }

  /**
   * On click of apply making an api call to update the user restriction to datbase.
   */
  updateUserRestrictionSettings() {
    this.loggendInUser.userSettings.userRestriction = this.userRestriction;
    this.userhttpService.updateUserSettings(this.loggendInUser).subscribe(
      data2 => {
        this.userhttpService.loggendInUser = data2;
        sessionStorage.setItem('userinfo', JSON.stringify(data2));
        sessionStorage.setItem("isloaded","true");
        // alert('Settings Updated');
        this.successNotification('Settings Updated');
      }, error => {
        alert('User Restrictions Failed to Update');
      },()=>{
        window.location.reload();
      }
    );
    // if (JSON.stringify(this.userRestriction) !== JSON.stringify(this.userhttpService.loggendInUser.userSettings.userRestriction)) {
  
    // this.userhttpService.updateUserRestriction(this.userRestriction).subscribe(response => {
    //   alert('Settings Updated');
    //   this.userhttpService.loginUser().subscribe(
    //     data => {
    //       this.response = data;
    //       console.log(this.response);
    //       this.userhttpService.loggendInUser = this.response.userDetails as User;
    //       this.userhttpService.loggendInUser.showActiveUsersInfo = this.response.showActiveUsersInfo;
    //       if ('Y' !== this.userhttpService.loggendInUser.termsAndConditions) {
    //         document.getElementById('termsModal').setAttribute('visible', 'true')
    //       } else {
    //         sessionStorage.setItem('userinfo', JSON.stringify(this.userhttpService.loggendInUser));
    //       }
    //     });
    // },
    //   error => {
    //     alert('User Restrictions Failed to Update');
    //   });
    // }
  }

  /**
   * On clicking og cancel resetting the changes made by the user.
   */
  reset() {
    this.userRestriction = this.userhttpService.loggendInUser.userSettings.userRestriction;
  }

  fetchUserProfileImage(userEmailId: string) {
    this.userhttpService.fetchUserProfileImage(userEmailId).subscribe((userImage) => {
      if(userImage != null){
        this.userProfileImageURL = 'data:image/png;base64,' + userImage;
      }
      else {
        this.userProfileImageURL = 'assets/img/userDefault.png';
      }
      
    },
    (err) => {
      console.log(err);
    });
  }


// Updating the themeSetting
  updateThemeSetting(themeType){
    this.buttonClicked = false;
    if(this.themeType==='dark'){
      this.loggendInUser.userSettings.userThemeType = 0;
    }else{
      this.loggendInUser.userSettings.userThemeType = 1;
    }
  }

  successNotification(message){
    this.isShowNotificationSuccess = true;
    this.showSuccessMessage = message;
    setInterval(()=>{
      this.isShowNotificationSuccess = false;
    },5000);
  }
}